<template>
    <div class="partner-container">
        <a
            :href="linkUrl"
            target="_blank"
        >
            <v-img
                :src="img_url"
                height="auto"
            />
        </a>
    </div>
</template>
<script>
export default {
    name: 'HomePartnersCard',
    props: {
        imgUrl: String,
        linkUrl: String
    },
    computed: {
        img_url() { 
            return window.document.location.origin+'/'+this.imgUrl
        }
    }
}
</script>
<style lang="scss" scoped>
.partner-container {
    height: 136px;
}
</style>
